




























import { defineComponent, PropType } from "@vue/composition-api";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";
import { DataRange } from "./types";

export default defineComponent({
  name: "DataRangeSelector",
  components: {
    OccSelectboxDate
  },
  emits: ["change-date-from", "change-date-to"],
  props: {
    minDate: {
      type: [String, Date],
      default: ""
    },
    maxDate: {
      type: [String, Date],
      default: ""
    },
    dateRange: {
      type: Object as PropType<DataRange>,
      default: () => {
        return {
          from: "",
          to: ""
        };
      }
    }
  },
  setup(_props, { emit }) {
    const onChangeStartDate = (value: string) => {
      emit("change-date-from", value);
    };
    const onChangeEndDate = (value: string) => {
      emit("change-date-to", value);
    };

    return {
      onChangeStartDate,
      onChangeEndDate
    };
  }
});
